// eslint-disable-next-line no-unused-vars
export default function preloaderSettings (scene) {

	// TODO

}